import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});


// Tambahkan interceptor untuk menyertakan token dalam setiap request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // Sesuaikan dengan format autentikasi Anda
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
